<template>
  <div>
    <!-- <router-link :to="{ name: 'invoices.sales.new' }" class="button is-primary">Verkoop factuur aanmaken</router-link> -->
    <div class="columns spacing-top-20">
      <div class="column">
        <div class="columns">
          <div class="column is-4">
            <b-field label="Filteren">
                <b-input v-model="search"></b-input>
            </b-field>
          </div>
        </div>

        <b-table
          :data="filteredList"
          :paginated="true"
          :pagination-simple="false"
          :per-page="15"
          default-sort-direction="desc"
          default-sort="number">
          <template slot-scope="sales">
            <b-table-column field="number" width="100" label="Nr." sortable numeric>
              {{ sales.row.number }}
            </b-table-column>
            <b-table-column label="Debiteur">
              {{ sales.row.debiteur | debiteur }}
            </b-table-column>
            <b-table-column label="Datum">
              {{ sales.row.date | date('lll')}}
            </b-table-column>
            <b-table-column>
              <a @click="creditNote(sales.row.id)" :class="{ 'is-loading': sales.row.inprogress }" class="button is-danger">Crediteren</a>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      sales: 'salesCompleted',
      debiteuren: 'debiteuren'
    }),
    filteredList () {
      return this.sales.filter(invoice => {
        const search = this.search.toLowerCase()

        if (!search) {
          return true
        }

        // console.log(invoice)
        const debiteur = this.debiteuren.find((object) => {
          return String(object.subNr) === String(invoice.crediteur)
        })

        invoice.name = debiteur ? debiteur.acctName : ''

        for (let key in invoice) {
          const value = String(invoice[key]).toLowerCase()

          if (value.includes(search)) {
            return true
          }
        }

        for (let receipt of invoice.receipts) {
          for (let key in receipt) {
            const value = String(receipt[key]).toLowerCase()

            if (value.includes(search)) {
              return true
            }
          }
        }

        return false
      })
    }
  },
  async created () {
    await this.$store.dispatch('getDebiteuren')
    await this.$store.dispatch('getSalesCompleted')
  },
  data () {
    return {
      search: ''
    }
  },
  methods: {
    async creditNote (id) {
      this.$store.dispatch('saleInProgress', id)
      this.$forceUpdate()

      try {
        await this.$store.dispatch('creditNoteSale', id)
      } catch (error) {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het crediteren van de verkoop factuur.'
        })

        await this.$store.dispatch('saleCompletedProgress', id)
        this.$forceUpdate()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoices/sales/index.vue